export function transformMultilineStop(stopName: string, separator = '\n') {
  if (!stopName) return undefined;
  return stopName?.replace(';', separator) ?? stopName;
}

export function splitMultilineStop(stopName: string) {
  if (!stopName) return undefined;
  return stopName?.split(';') ?? undefined;
}

export default transformMultilineStop;
